// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as CountryRepo from "./CountryRepo.bs.js";
import * as DummyCountryRepo from "./DummyCountryRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyCountryRepo.T;
  } else {
    return CountryRepo.T;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
